import { ClientAuthResponse, ClientLoginResponse } from '@common/model/client/auth';
import { AsyncResult, Result } from '@youhelp-ru/core';
import React, { ComponentType } from 'react';
import { OAuthVariants } from '@common/model/client/oauth/oauthService';
import { IModalManager } from '@cp/shared/modal';
import { ClientProfileViewModel } from '@common/model/client';
import { AuthError } from 'src/features/auth/model/AuthError';
import { ClientSelection } from 'src/entities/client';

export enum LoginStrategy {
  Phone = 'phone',
  Email = 'email',
  OAuth = 'oauth',
}

export const DEFAULT_LOGIN_STRATEGY = LoginStrategy.Phone;

export type LoginFeatureResult = ClientLoginResponse & { loginStrategy: LoginStrategy; login: string };

export type AuthOption = {
  strategy: LoginStrategy;
  provider: OAuthVariants | null;
  enabled: boolean;
  Component: ComponentType<{ onClick?: any }>;
};

export type SelectedAuthOption = Pick<AuthOption, 'strategy' | 'provider'>;

export type AuthStrategyImpl = (manager: IModalManager) => Promise<Result<ClientAuthResponse, AuthError>>;

export interface LoginModalOwnProps {
  desc?: React.ReactNode;
  loginStrategy?: LoginStrategy;
}

export type AuthFeature = (clientSelection?: ClientSelection) => AsyncResult<ClientProfileViewModel, AuthError>;
export type QuizQuestions = Array<keyof ClientSelection>;
